import { MIN_BOOKING_REQUEST_NIGHTS } from '../server/services/quote-engine';

// Derives the booking-quote state for analytics + CTA feedback. Centralizes the
// branch that used to live inline in QuoteWidget.onCta so the apartment-page
// instrumentation and the CTA handler agree on one definition.
//
// - 'available'   — backend returned a bookable quote (quote.available === true)
// - 'min_nights'  — priced and available, but too short to send a booking
//                   request (nights < MIN_BOOKING_REQUEST_NIGHTS)
// - 'unavailable' — both dates picked but not bookable (booked / etc)
// - 'no_dates'    — at least one date missing, so no quote could be computed

export type QuoteState = 'available' | 'min_nights' | 'unavailable' | 'no_dates';

export function quoteState(i: {
  available?: boolean;
  hasCheckin: boolean;
  hasCheckout: boolean;
  nights?: number;
}): QuoteState {
  if (i.available) {
    return i.nights != null && i.nights < MIN_BOOKING_REQUEST_NIGHTS ? 'min_nights' : 'available';
  }
  return i.hasCheckin && i.hasCheckout ? 'unavailable' : 'no_dates';
}
